// var fetchLookup = function(target, functionName, cached) {
//     if(!this[target].length || !cached) {
//         this["loading"][target] = true;
//         functionName
//             .then(result => {
//                 this[target] = result.data;
//                 this["loading"][target] = false;
//             })
//             .catch(() => {
//                 fetchLookup(target, functionName);
//             });
//     }
// }

// module.exports = fetchLookup;


var fetchLookups = function(lookups) {
    lookups.forEach(({target, action, cached}) => {
        if(!this[target].length || !cached) {
            this["loading"][target] = true;
            action
                .then(result => {
                    this[target] = result.data;
                    this["loading"][target] = false;
                })
                .catch(() => {
                    fetchLookups(target, action);
                });
        }
    })
}

module.exports = fetchLookups;